
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("feccm", function(module, exports) {

$parcel$export(module.exports, "register", () => $b161a03040dd5cca$export$6503ec6e8aabbaf, (v) => $b161a03040dd5cca$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b161a03040dd5cca$export$f7ad0328861e2f03, (v) => $b161a03040dd5cca$export$f7ad0328861e2f03 = v);
var $b161a03040dd5cca$export$6503ec6e8aabbaf;
var $b161a03040dd5cca$export$f7ad0328861e2f03;
"use strict";
var $b161a03040dd5cca$var$mapping = new Map();
function $b161a03040dd5cca$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b161a03040dd5cca$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b161a03040dd5cca$var$resolve(id) {
    var resolved = $b161a03040dd5cca$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b161a03040dd5cca$export$6503ec6e8aabbaf = $b161a03040dd5cca$var$register;
$b161a03040dd5cca$export$f7ad0328861e2f03 = $b161a03040dd5cca$var$resolve;

});

parcelRegister("zjQ43", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $06a2a88f99a898e8$export$bdfd709ae4826697, (v) => $06a2a88f99a898e8$export$bdfd709ae4826697 = v);
var $06a2a88f99a898e8$export$bdfd709ae4826697;
var $06a2a88f99a898e8$export$c9e73fbda7da57b6;
var $06a2a88f99a898e8$export$5a759dc7a1cfb72a;
"use strict";
var $06a2a88f99a898e8$var$bundleURL = {};
function $06a2a88f99a898e8$var$getBundleURLCached(id) {
    var value = $06a2a88f99a898e8$var$bundleURL[id];
    if (!value) {
        value = $06a2a88f99a898e8$var$getBundleURL();
        $06a2a88f99a898e8$var$bundleURL[id] = value;
    }
    return value;
}
function $06a2a88f99a898e8$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $06a2a88f99a898e8$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $06a2a88f99a898e8$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $06a2a88f99a898e8$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$06a2a88f99a898e8$export$bdfd709ae4826697 = $06a2a88f99a898e8$var$getBundleURLCached;
$06a2a88f99a898e8$export$c9e73fbda7da57b6 = $06a2a88f99a898e8$var$getBaseURL;
$06a2a88f99a898e8$export$5a759dc7a1cfb72a = $06a2a88f99a898e8$var$getOrigin;

});

parcelRegister("20lOL", function(module, exports) {


module.exports = (parcelRequire("7i0aA"))((parcelRequire("feccm")).resolve("kmSJm")).then(()=>parcelRequire("fsPsb"));

});
parcelRegister("7i0aA", function(module, exports) {
"use strict";

var $eNOTF = parcelRequire("eNOTF");
module.exports = $eNOTF(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("eNOTF", function(module, exports) {
"use strict";
var $ac6d1f589c2d7ff3$var$cachedBundles = {};
var $ac6d1f589c2d7ff3$var$cachedPreloads = {};
var $ac6d1f589c2d7ff3$var$cachedPrefetches = {};
function $ac6d1f589c2d7ff3$var$getCache(type) {
    switch(type){
        case "preload":
            return $ac6d1f589c2d7ff3$var$cachedPreloads;
        case "prefetch":
            return $ac6d1f589c2d7ff3$var$cachedPrefetches;
        default:
            return $ac6d1f589c2d7ff3$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ac6d1f589c2d7ff3$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $ff19114cc403cffc$exports = {};


(parcelRequire("feccm")).register((parcelRequire("zjQ43")).getBundleURL("1kDnh"), JSON.parse('["1kDnh","index.2543e4bf.js","kmSJm","lib-fetch.8eb48ca9.js"]'));


var $8Mzka = parcelRequire("8Mzka");

var $iqkw9 = parcelRequire("iqkw9");

var $6FAcS = parcelRequire("6FAcS");
const { byEnvironment: $d4cb253697a79b79$var$byEnvironment, ENVIRONMENTS: $d4cb253697a79b79$var$ENVIRONMENTS } = (0, $8Mzka.environments);
// prestage entries mirror stage: prestage hits stage analytics/launch at runtime.
// preprod entries map to prod values: preprod hits prod APIs/analytics at
// runtime even though the code itself was served from the preprod CDN. The
// iframe-side env-mapper resolves preprod origins to ENVIRONMENTS.prod, so
// these preprod branches are reachable only when something explicitly forces
// the preprod env (currently nothing does, but the byEnvironment map type
// requires the entry).
const $d4cb253697a79b79$var$marketingConfig = $d4cb253697a79b79$var$byEnvironment((0, $8Mzka.envs).getAppEnv);
const $d4cb253697a79b79$export$fa54871c0f9704d1 = ()=>$d4cb253697a79b79$var$marketingConfig({
        [$d4cb253697a79b79$var$ENVIRONMENTS.local]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-20e1cb549f8d-development.min.js",
        [$d4cb253697a79b79$var$ENVIRONMENTS.stage]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-60f5ad31dcdc-staging.min.js",
        [$d4cb253697a79b79$var$ENVIRONMENTS.prestage]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-60f5ad31dcdc-staging.min.js",
        [$d4cb253697a79b79$var$ENVIRONMENTS.preprod]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-1b1712458f6e.min.js",
        [$d4cb253697a79b79$var$ENVIRONMENTS.prod]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-1b1712458f6e.min.js"
    });
const $d4cb253697a79b79$export$433df29d39384e33 = ()=>$d4cb253697a79b79$var$marketingConfig({
        [$d4cb253697a79b79$var$ENVIRONMENTS.local]: ()=>"907a6882-ab0e-470b-b9e2-dacfef7a4b56",
        [$d4cb253697a79b79$var$ENVIRONMENTS.stage]: ()=>"907a6882-ab0e-470b-b9e2-dacfef7a4b56",
        [$d4cb253697a79b79$var$ENVIRONMENTS.prestage]: ()=>"907a6882-ab0e-470b-b9e2-dacfef7a4b56",
        [$d4cb253697a79b79$var$ENVIRONMENTS.preprod]: ()=>"6f975362-e0ca-4f3a-9e2c-8d45aff664ac",
        [$d4cb253697a79b79$var$ENVIRONMENTS.prod]: ()=>"6f975362-e0ca-4f3a-9e2c-8d45aff664ac"
    });
window.marketingtech = {
    adobe: {
        launch: {
            url: $d4cb253697a79b79$export$fa54871c0f9704d1(),
            controlPageLoad: true
        },
        alloy: {
            edgeConfigId: $d4cb253697a79b79$export$433df29d39384e33()
        },
        target: false,
        audienceManager: false
    }
};
function $d4cb253697a79b79$var$handleAnalyticsEvents(events) {
    events.forEach((event)=>{
        event.cycle();
    });
}

(parcelRequire("20lOL")).then(async (initialize)=>{
    // Initialize library code
    await initialize.default();
    const analyticsStore = (0, $iqkw9.getAnalyticsStore)();
    // Set up debounced handler for the events and set loading done
    analyticsStore.setState({
        isAnalyticsLoading: false
    });
    // Handle events that might have accumulated meanwhile
    const appState = await (0, $iqkw9.getApplicationState)();
    const { queryState: { ac: ac, client_id: client_id, locale: locale }, config: { variant: variant } } = appState;
    const analyticsLocaleFormat = locale.replaceAll("_", "-");
    window.alloy_all.set(`${(0, $6FAcS.PAGE_INFO_PROP)}.language`, analyticsLocaleFormat);
    window.alloy_all.set(`${(0, $6FAcS.PAGE_INFO_PROP)}.siteSection`, "IMS-Light");
    window.alloy_all.set(`${(0, $6FAcS.PAGE_INFO_PROP)}.version`, "2.0 Light");
    window.alloy_all.set(`${(0, $6FAcS.IMS_CLIENT_PROP)}.clientID`, client_id);
    if (ac) window.alloy_all.set(`${(0, $6FAcS.IMS_CLIENT_PROP)}.appCodeValue.ac`, ac);
    // Handle all events that have stacked up until now
    const { takeEvents: takeEvents } = analyticsStore.getState();
    $d4cb253697a79b79$var$handleAnalyticsEvents(takeEvents());
    // Handle future events
    analyticsStore.subscribe((state)=>{
        const { takeEvents: takeEvents } = state;
        const events = takeEvents();
        if (events.length > 0) $d4cb253697a79b79$var$handleAnalyticsEvents(events);
    });
});


//# sourceMappingURL=index.2543e4bf.js.map
